import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { SmrAndAsuAwardsReportFilter } from "./smr-and-asu-awards-report-filters";

@Injectable({
    providedIn: 'root'
})

export class SmrAndAsuAwardsReportService {

    constructor(protected http: HttpClient) {

    }

    baseurl = environment.apiBaseUrl + 'SMRAndASUAwards';

    getSmrAndAsuAwardsReportFilter() {
        return this.http.get<any[]>(this.baseurl);
    }

    getH2SteamReformerAwardsReport(filter: SmrAndAsuAwardsReportFilter) {
        return this.http.post<any[]>(this.baseurl + '/GetSteamReformerReport', filter);
    }

    getASUAwardsReport(filter: SmrAndAsuAwardsReportFilter) {
        return this.http.post<any[]>(this.baseurl + '/GetASUAwardsReport', filter);
    }
}